import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { StructureOrganizative, CacheService } from "mapfre-auditlib";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
   providedIn: "root"
})
export class TypesStateNodesService {

   className = 'TypesStateNodesService';

   constructor(private http: HttpClient, private cacheService: CacheService) { }

   getAll(cache = true, cacheKey = "allTypeStateNodesService"): Observable<any[]> {
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
       } else {
         let observable = this.http.get<any[]>(environment.base_URL + "/types-state-nodes/").pipe(map((res) => {
         this.cacheService.updateCacheData(res, cacheKey)
         return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
   }

}
